var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @eslint-community/eslint-comments/disable-enable-pair -- see below
/* eslint-disable @typescript-eslint/naming-convention -- the current settings of this rule
doesn't make much sense for JSX files
where all functional React components MUST start with a capital letter */
import { FloatingFocusManager, useMergeRefs } from '@floating-ui/react';
import { useEffect, useId, useRef, useState, } from 'react';
import { ENTER_KEY, ESCAPE_KEY, TAB_KEY } from '#constants';
import { C } from '#integrations';
import { safeHidePopover, safeShowPopover } from '#services';
import { FLOATING_BOX_DEFAULT_OFFSET, FLOATING_BOX_DEFAULT_POPUP_KIND, } from './FloatingBox.constants';
import { FloatingBoxTestIdFactory } from './interactions';
import { useFloatingBox } from './useFloatingBox';
import styles from './FloatingBox.module.css';
const SHADOW_CLASS_MAP = {
    shallow: styles.ShadowShallow,
    mid: styles.ShadowMid,
    deep: styles.ShadowDeep,
};
export const FloatingBox = ({ 'aria-label': ariaLabel, Content, contentOffset = FLOATING_BOX_DEFAULT_OFFSET, 'data-testid': testid, hasBackdrop = false, id, isModal = false, placement = 'bottom-end', renderTrigger, role, shadow = 'shallow', shouldCloseFloatingBox, shouldOpenFloatingBox, shouldPreventClose = false, stopEventPropagation = false, trackFloatingBoxState, }) => {
    _react_refresh_temp_2();
    const contentRef = useRef(null);
    const generatedContentId = useId();
    const contentId = id ?? generatedContentId;
    const [isVisible, setIsVisible] = useState(false);
    const { closeFloatingBox, context, floatingBoxProps, isFloatingBoxActive, triggerProps, } = useFloatingBox({
        contentOffset,
        placement,
        shouldCloseFloatingBox,
        shouldOpenFloatingBox,
    });
    const contentMergedRef = useMergeRefs([contentRef, floatingBoxProps.ref]);
    useEffect(() => {
        if (trackFloatingBoxState) {
            trackFloatingBoxState(isFloatingBoxActive);
        }
    }, [isFloatingBoxActive, trackFloatingBoxState]);
    useEffect(() => {
        if (isFloatingBoxActive) {
            setIsVisible(true);
        }
    }, [isFloatingBoxActive]);
    const handleClick = (event) => {
        if (shouldPreventClose) {
            return;
        }
        if (stopEventPropagation) {
            event.stopPropagation();
        }
        closeFloatingBox();
    };
    // An item may open a modal or drawer, which on close refocuses what held focus on open.
    const focusTrigger = () => {
        const trigger = context.elements.domReference;
        if (!shouldPreventClose && trigger instanceof HTMLElement) {
            trigger.focus({ preventScroll: true });
        }
    };
    const handleKeyDownCapture = (event) => {
        if (event.key === ENTER_KEY) {
            focusTrigger();
        }
    };
    const handleKeyDown = (event) => {
        if (shouldPreventClose && event.key !== ESCAPE_KEY) {
            return;
        }
        if ([ENTER_KEY, ESCAPE_KEY, TAB_KEY].includes(event.key)) {
            event.stopPropagation();
            event.preventDefault();
            closeFloatingBox();
        }
    };
    useEffect(() => {
        if (isFloatingBoxActive) {
            safeShowPopover(contentRef.current);
        }
    }, [isFloatingBoxActive]);
    return (_jsxs(_Fragment, { children: [renderTrigger({
                ...triggerProps,
                ...(isFloatingBoxActive && { 'aria-controls': contentId }),
                'aria-expanded': isFloatingBoxActive,
                'aria-haspopup': role ?? FLOATING_BOX_DEFAULT_POPUP_KIND,
                isFloatingBoxActive,
            }), isVisible && (_jsx(FloatingFocusManager, { context: context, disabled: !isFloatingBoxActive, guards: false, modal: isModal, children: _jsx("div", { className: C(styles.Content, isFloatingBoxActive && styles.ContentVisible, hasBackdrop && styles.HasBackdrop, SHADOW_CLASS_MAP[shadow]), "data-testid": FloatingBoxTestIdFactory.getFloatingBoxTestId(testid), id: contentId, onClick: handleClick, onClickCapture: focusTrigger, onKeyDown: handleKeyDown, onKeyDownCapture: handleKeyDownCapture, onTransitionEnd: (e) => {
                        // Delay the element removal from DOM.
                        // The if is here to set the value only when
                        // the result of animation is a collapsed container.
                        // This marks the end of closing animation.
                        if (e.currentTarget.clientHeight === 0) {
                            safeHidePopover(contentRef.current);
                            setIsVisible(false);
                        }
                    }, popover: "manual", ref: contentMergedRef, style: floatingBoxProps.style, ...(role && { role: role }), ...(ariaLabel && { 'aria-label': ariaLabel }), children: Content }) }))] }));
};
_react_refresh_temp_1 = FloatingBox;
$RefreshReg$(_react_refresh_temp_1, "FloatingBox");
_react_refresh_temp_2(FloatingBox, "iKUocVHlPFUO68FKgou6/B+6chk=", false, () => [useFloatingBox, useMergeRefs]);
